import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,Divider,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  Grid,
  ListItemIcon,
  ListItemText,
  DialogActions,
  Checkbox,
  DialogContent,
  DialogTitle,
  Dialog,
  
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { IconButton } from "@mui/material";
import * as XLSX from "xlsx";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../AuthProvider"; 
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useLocation } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StudentApplicationList = () => {
  const navigate = useNavigate();
  const { oId,board,userId,role,pId } = useAuth();
const { state } = useLocation();
const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data

  const [loading, setLoading] = useState(true);

  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A
// SSC states
const [sscClassSectionData, setSscClassSectionData] = useState([]);
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState("");
const [sscSelectedSection, setSscSelectedSection] = useState("");

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState("");
const [interSelectedSection, setInterSelectedSection] = useState("");
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");



const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
// console.log("selected mode :"+mode);
const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag

//delete dialog states
const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null);
const [confirmChecked, setConfirmChecked] = useState(false);






  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

const [totalStudents, setTotalStudents] = useState(0);




  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  // const isPrincipal = role?.startsWith("PRINCIPAL" || "ORGANIZATION") || false;
  const isPrincipal = role?.startsWith("PRINCIPAL") || role?.startsWith("ORGANIZATION") || false;
                                                                          
  const UserId = userId || selectedUsers;
  console.log("Selected User:",UserId);


 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${PrincipalId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {

    fetchUsers();

}, []); // ✅ Only runs on mount 


  

// useEffect(() => {
//   // ✅ Strong guard: only call API when UserId and oId are both truthy
//   if (UserId && oId) {
//     fetchGetAllTableData();
//   }
// }, [UserId, oId]);

// const fetchGetAllTableData = async () => {
//   // ✅ Optional double check — not strictly necessary if guarded in useEffect
//   if (!UserId || !oId) return;

//   setLoading(true);
//   setHasFetchedOnce(false);

//   try {
//     const response = await fetch(
//       `${baseUrl}/api/admission/adm/getAllOrganizationStudents/${oId}/${UserId}`
//     );

//     if (!response.ok) {
//       throw new Error('Failed to fetch student data');
//     }

//     const data = await response.json();

//     if (Array.isArray(data)) {
//       setOriginalData(data);
//       setFilteredData(data);
//     } else {
//       setOriginalData([]);
//       setFilteredData([]);
//     }
//   } catch (error) {
//     console.error('Error fetching table data:', error);
//   } finally {
//     setLoading(false);
//     setHasFetchedOnce(true);
//   }
// };







// -------------------------------------------
//           For SSC functions
// -------------------------------------------


// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };

const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


// ---- Fetch Table Data for SSC ----
// const fetchClassSectionTableData = async () => {
//   if (!UserId || !sscSelectedClass || !sscSelectedSection) {
//     setFilteredData([]);
//     setOriginalData([]);
//     setTotalStudents(0);
//     setLoading(false);
//     return;
//   }

//   setLoading(true);
//   try {
//     const response = await fetch(
//       `${baseUrl}/fcm/notifications/tokens/classWise?principal=${pId}&romanClass=${sscSelectedClass}&sections=${sscSelectedSection}`
//     );

//     const result = await response.json();

//     if (Array.isArray(result.data)) {
//       // 🔹 1. Group by section
//       const sectionMap = result.data.reduce((acc, item) => {
//         const section = item.sections || "Unknown";
//         if (!acc[section]) acc[section] = [];
//         acc[section].push(item);
//         return acc;
//       }, {});

//       // 🔹 2. Sort each section by rollNumber
//       Object.keys(sectionMap).forEach(section => {
//         sectionMap[section].sort(
//           (a, b) => Number(a.rollNumber) - Number(b.rollNumber)
//         );
//       });

//       // 🔹 3. Order sections: A first, then B
//       const orderedSections = ["Section-A", "Section-B"];

//       const finalSortedData = orderedSections.flatMap(
//         section => sectionMap[section] || []
//       );

//       setOriginalData(finalSortedData);
//       setFilteredData(finalSortedData);
//       setTotalStudents(result.totalCount || finalSortedData.length);
//     } else {
//       setOriginalData([]);
//       setFilteredData([]);
//       setTotalStudents(0);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC table data:", error);
//   } finally {
//     setLoading(false);
//   }
// };

const fetchClassSectionTableData = async () => {
  if (!UserId || !sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setTotalStudents(0);
    setLoading(false);
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/fcm/notifications/tokens/classWise?principal=${pId}&romanClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );

    const result = await response.json();

    if (Array.isArray(result.data)) {

      // 🔹 1. Remove duplicate students by userId
      const uniqueStudentsMap = new Map();

      result.data.forEach(item => {
        if (!uniqueStudentsMap.has(item.userId)) {
          uniqueStudentsMap.set(item.userId, item);
        }
      });

      const uniqueStudents = Array.from(uniqueStudentsMap.values());

      // 🔹 2. Group by section
      const sectionMap = uniqueStudents.reduce((acc, item) => {
        const section = item.sections || "Unknown";
        if (!acc[section]) acc[section] = [];
        acc[section].push(item);
        return acc;
      }, {});

      // 🔹 3. Sort each section by rollNumber
      Object.keys(sectionMap).forEach(section => {
        sectionMap[section].sort(
          (a, b) => Number(a.rollNumber) - Number(b.rollNumber)
        );
      });

      // 🔹 4. Order sections
      const orderedSections = ["Section-A", "Section-B"];

      const finalSortedData = orderedSections.flatMap(
        section => sectionMap[section] || []
      );

      setOriginalData(finalSortedData);
      setFilteredData(finalSortedData);

      // 🔹 5. Correct total count (after removing duplicates)
      setTotalStudents(uniqueStudents.length);

    } else {
      setOriginalData([]);
      setFilteredData([]);
      setTotalStudents(0);
    }

  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};







// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data[0] || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);


// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionOnlyStudents/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {

       // ✅ Sort by Roll No Ascending (1,2,3,4...)
      const sortedData = data.sort(
        (a, b) => Number(a.rollNumber) - Number(b.rollNumber)
      );

      setOriginalData(sortedData);
      setFilteredData(sortedData);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here



// INTERMEDIATE: When class or course type changes, update sections
// useEffect(() => {
//   const updateIntermediateSections = async () => {
//     if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
//       await fetchSectionsData();
//     }
//   };
//   updateIntermediateSections();
// }, [interSelectedClass, selectedCourseType, board]);






//Fetch tables apis for ssc and intermediate
useEffect(() => {
  const fetchData = () => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection ) {
        fetchClassSectionTableData();
      } else {
        setOriginalData([])
        setFilteredData([]);
        setLoading(false);
      }
    } else if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection ) {
        fetchCourseClassSectionTableData();
      } else {
        setOriginalData([])
        setFilteredData([]);
        setLoading(false);
      }
    }
  };

  fetchData();
}, [UserId, board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection]);

// useEffect(() => {
//   // 1. do nothing until the initial list is ready *and* we have a UserId
//   if (!hasFetchedOnce || !UserId) return;

//   const isSSC  = board === "SSC";
//   const isINTER = board === "INTERMEDIATE";

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       if (
//         isSSC &&
//         sscSelectedClass &&
//         sscSelectedSection &&
//         mode === "classSection"
//       ) {
//         // make sure the helper receives UserId if required
//         await fetchClassSectionTableData({ oId, UserId, sscSelectedClass, sscSelectedSection });
//       } else if (
//         isINTER &&
//         selectedCourseType &&
//         interSelectedClass &&
//         interSelectedSection &&
//         mode === "classSection"
//       ) {
//         await fetchCourseClassSectionTableData({
//           oId,
//           UserId,
//           selectedCourseType,
//           interSelectedClass,
//           interSelectedSection
//         });
//       } else {
//         // filters incomplete - clear the view
//         setOriginalData([]);
//         setFilteredData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching filtered data", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchData();
// }, [
//   board,
//   sscSelectedClass,
//   sscSelectedSection,
//   selectedCourseType,
//   interSelectedClass,
//   interSelectedSection,
//   mode,
//   hasFetchedOnce,
//   UserId           // 2. added here
// ]);


//   useEffect(() => {
//   if (!searchQuery) {
//     setFilteredData(originalData); // Reset if no search term
//     return;
//   }

//   const searchTerm = searchQuery.trim().toLowerCase();

//   const result = originalData.filter((student) => {
//     const admissionNo = String(student.customAdmissionNumber || "").toLowerCase();
//     const rollNo = String(student.studentRollNumber || "").toLowerCase();
//     const firstName = String(student.firstName || "").toLowerCase();
//     const lastName = String(student.lastName || "").toLowerCase();
//     const fullName = `${firstName} ${lastName}`.trim(); // combine names
//     const primaryContact = String(student.primaryContact || "").toLowerCase();
//     const fathersFirstName = String(student.fathersFirstName || "").toLowerCase();
//     const fathersLastName = String(student.fathersLastName || "").toLowerCase();
//     const fathersFullName = `${fathersFirstName} ${fathersLastName}`.trim();

//     return (
//       admissionNo === searchTerm ||
//       rollNo === searchTerm ||
//       fullName === searchTerm ||
//       firstName === searchTerm ||
//       lastName === searchTerm ||
//       primaryContact === searchTerm ||
//       fathersFullName === searchTerm ||
//       fathersFirstName === searchTerm ||
//       fathersLastName === searchTerm
//     );
//   });

//   setFilteredData(result);
// }, [searchQuery, originalData]);

const filteredResults = filteredData.filter((student) => {
  const admissionNo = String(student.customAdmissionNumber || "").toLowerCase();
  const rollNo = String(student.rollNumber || "").toLowerCase();
  const firstName = String(student.firstName || "").toLowerCase();
  const lastName = String(student.lastName || "").toLowerCase();
  const fullName = `${firstName} ${lastName}`.trim();
  const primaryContact = String(student.primaryContact || "").toLowerCase();
  const fathersFirstName = String(student.fathersFirstName || "").toLowerCase();
  const fathersLastName = String(student.fathersLastName || "").toLowerCase();
  const fathersFullName = `${fathersFirstName} ${fathersLastName}`.trim();

  return (
    admissionNo.includes(searchQuery.toLowerCase()) ||
    rollNo.includes(searchQuery.toLowerCase()) ||
    firstName.includes(searchQuery.toLowerCase()) ||
    lastName.includes(searchQuery.toLowerCase()) ||
    fullName.includes(searchQuery.toLowerCase()) ||
    primaryContact.includes(searchQuery.toLowerCase()) ||
    fathersFirstName.includes(searchQuery.toLowerCase()) ||
    fathersLastName.includes(searchQuery.toLowerCase()) ||
    fathersFullName.includes(searchQuery.toLowerCase())
  );
});

  





  

  //Delete API for student
// const handleDelete = async (row) => {
//   const result = await Swal.fire({
//     title: 'Are you sure ?',
//      html: `Do you really want to delete this student <span style="color: red; font-weight: bold;">${row.firstName} ${row.lastName}</span>?`,
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonColor: '#d33',
//     cancelButtonColor: '#3085d6',
//     confirmButtonText: 'Yes, delete it!',
//   });

//   if (result.isConfirmed) {
//     try {
//       const res = await fetch(`${baseUrl}/api/admission/delete/${row.studentId}`, {
//         method: 'DELETE',
//       });

//       let data;
//       const contentType = res.headers.get("content-type");

//       if (contentType && contentType.includes("application/json")) {
//         data = await res.json();
//       } else {
//         data = await res.text();
//       }

//       if (!res.ok) {
//         // If response is not OK, show server message
//         throw new Error(data?.message || data || 'Failed to delete student');
//       }

//       toast.success('Student deleted successfully!', {
//         autoClose: 2000,
//         position: "top-right",
//       });

//       fetchGetAllTableData(); // Refresh data

//     } catch (error) {
//       toast.error(`${error.message}`, {
//         autoClose: 2000,
//         position: "top-right",
//       });
//       console.error('Delete error:', error);
//     }
//   }
// };

const handleOpenDeleteDialog = (row) => {
  setDeleteTarget(row);
  setConfirmChecked(false); // Reset checkbox
  setOpenDeleteDialog(true);
};


const confirmDelete = async () => {
  if (!deleteTarget) return;

  try {
    const res = await fetch(`${baseUrl}/api/admission/delete/${deleteTarget.studentId}`, {
      method: 'DELETE',
    });

    let data;
    const contentType = res.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      data = await res.json();
    } else {
      data = await res.text();
    }

    if (!res.ok) {
      throw new Error(data?.message || data || 'Failed to delete student');
    }

    toast.success('Student and all related records deleted successfully!', {
      autoClose: 2000,
      position: "top-right",
    });

    setOpenDeleteDialog(false);
    // fetchGetAllTableData(); // Refresh data
    // ✅ Decide which fetch function to call
    if (
      sscSelectedClass &&
      sscSelectedSection &&
      board === "SSC"
    ) {
      fetchClassSectionTableData();
    } else {
      // fetchGetAllTableData();
    }
  } catch (error) {
    toast.error(`${error.message}`, {
      autoClose: 2000,
      position: "top-right",
    });
    console.error('Delete error:', error);
  }
};






//   const exportToExcel = () => {
//     const isIntermediate = board === "INTERMEDIATE";
//     const dynamicKey = isIntermediate ? "Year" : "Class";

//     const processedData = filteredData.map(
//       ({
//         customAdmissionNumber,
//         admissionDate,
//         course,
//         romanNumberClass,
//         sections,
//         firstName,
//         lastName,
//         gender,
//         fathersFirstName,
//         fathersLastName,
//         mothersFirstName,
//         mothersLastName,
//         primaryContact,
//       }) => ({
//         AdmissionNumber: customAdmissionNumber,
//         AdmissionDate: admissionDate,
//         ...(isIntermediate ? { Course: course } : {}),
//       [dynamicKey]: romanNumberClass,
        
//         Section: sections,
//         StudentName: `${firstName} ${lastName}`,
//         Gender: gender,
//         FatherName: `${fathersFirstName} ${fathersLastName}`,
//         MotherName: `${mothersFirstName} ${mothersLastName}`,
//         Phone: primaryContact,
//       })
//     );

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet(
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_StudentsList`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_StudentsList`
//     : "AllStudentsList"
// );

    

//     // Add headers
//     worksheet.columns = [
//       { header: "Admission No", key: "AdmissionNumber", width: 15 },
//       { header: "Admission Date", key: "AdmissionDate", width: 15 },
//       ...(board === "INTERMEDIATE"
//         ? [{ header: "Course", key: "Course", width: 15 }]
//         : []),
//       { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
//       { header: "Section", key: "Section", width: 10 },
//       { header: "Student Name", key: "StudentName", width: 25 },
//       { header: "Gender", key: "Gender", width: 10 },
//       { header: "Father Name", key: "FatherName", width: 20 },
//       { header: "Mother Name", key: "MotherName", width: 20 },
//       { header: "Phone", key: "Phone", width: 15 },
//     ];

//     // Add data to worksheet
//     processedData.forEach((data) => {
//       worksheet.addRow(data);
//     });

//     // Style headers
//     worksheet.getRow(1).eachCell((cell) => {
//       cell.font = { bold: true };
//       cell.alignment = { horizontal: "center" };
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "87CEEB" }, // Light Blue Header
//       };
//     });

//     // Write and download file
//     workbook.xlsx.writeBuffer().then((buffer) => {
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
   
//    link.download = 
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_StudentsList.xlsx`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_StudentsList.xlsx`
//     : "AllStudentsList.xlsx";


//       link.click();
//     });
    

//     handleExportClose();
//   };

  // Export to PDF
  
  const exportToExcel = () => {
  const isIntermediate = board === "INTERMEDIATE";
  const dynamicKey = isIntermediate ? "Year" : "Class";

  const processedData = filteredData.map((student,index) => ({
    // AdmissionNumber: student.customAdmissionNumber,
  "S.NO": index + 1,

    
    StudentName: `${student.firstName} ${student.lastName}`,
     StudentRollNumber: student.rollNumber,
     ...(isIntermediate ? { Course: student.course } : {}),
    [dynamicKey]: student.romanNumberClass,
    Section: student.sections,
    // Gender: student.gender,
    FatherName: `${student.fathersFirstName} ${student.fathersLastName}`,
    // MotherName: `${student.mothersFirstName} ${student.mothersLastName}`,
    Phone: student.primaryContact,

    // Additional Fields
    // AcademicYear: student.academicYear,
    // StudentJoinedYear: student.studentJoinedYear,
    // Status: student.status,
    // DOB: student.dob,
    // PEN: student.pen,
    // StudentHallTicket: student.studentHallTicket,
    // TutionFee: student.tutionFee,
    // AdmissionFee: student.admissionFee,
    // StudentId: student.studentId,
    // GeneratedAdmissionNumber: student.generatedAdmissionNumber,
   
    // StudentJoinedClass: student.studentJoinedClass,
    // BusAssignedStatus: student.busAssignedStatus,
  }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(
    (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
      ? `${interSelectedClass}-${interSelectedSection}_StudentsList`
      : (board === "SSC" && sscSelectedClass && sscSelectedSection)
      ? `${sscSelectedClass}-${sscSelectedSection}_StudentsList`
      : "AllStudentsList"
  );

  // Column Headers
  worksheet.columns = [
    // { header: "Admission No", key: "AdmissionNumber", width: 15 },
    { header: "S.NO", key: "S.NO", width: 15 },
    
    { header: "Student Name", key: "StudentName", width: 25 },
        { header: "Roll Number", key: "StudentRollNumber", width: 15 },
        ...(board === "INTERMEDIATE" ? [{ header: "Course", key: "Course", width: 15 }] : []),
    { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
    { header: "Section", key: "Section", width: 15 },
    // { header: "Gender", key: "Gender", width: 10 },
    { header: "Father Name", key: "FatherName", width: 20 },
    // { header: "Mother Name", key: "MotherName", width: 20 },
    { header: "Phone", key: "Phone", width: 15 },

    // Additional Fields
    // { header: "Academic Year", key: "AcademicYear", width: 15 },
    // { header: "Student Joined Year", key: "StudentJoinedYear", width: 20 },
    // { header: "Status", key: "Status", width: 15 },
    // { header: "Date of Birth", key: "DOB", width: 15 },
    // { header: "PEN", key: "PEN", width: 15 },
    // { header: "Student Hall Ticket", key: "StudentHallTicket", width: 20 },
    // { header: "Tution Fee", key: "TutionFee", width: 15 },
    // { header: "Admission Fee", key: "AdmissionFee", width: 15 },
    // { header: "Student ID", key: "StudentId", width: 20 },
    // { header: "Generated Admission No", key: "GeneratedAdmissionNumber", width: 20 },

    // { header: "Joined Class", key: "StudentJoinedClass", width: 15 },
    // { header: "Bus Assigned Status", key: "BusAssignedStatus", width: 20 },
  ];

  // Add rows
  processedData.forEach((data) => worksheet.addRow(data));

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" },
    };
  });

  // Trigger download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download =
      (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
        ? `${interSelectedClass}-${interSelectedSection}_StudentsList.xlsx`
        : (board === "SSC" && sscSelectedClass && sscSelectedSection)
        ? `${sscSelectedClass}-${sscSelectedSection}_StudentsList.xlsx`
        : "AllStudentsList.xlsx";
    link.click();
  });

  handleExportClose();
};

  
  const exportToPDF = () => {
  const doc = new jsPDF();
  const isIntermediate = board === "INTERMEDIATE";
  const dynamicKey = isIntermediate ? "Year" : "Class";

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");

  if (isIntermediate && interSelectedClass && interSelectedSection) {
    doc.text(`${interSelectedClass}-${interSelectedSection}_Students List`, 10, 8);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.text(`${sscSelectedClass}-${sscSelectedSection}_Students List`, 10, 8);
  } else {
    doc.text(`All Students List`, 10, 8);
  }

  // Generated date
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On:", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // 🔹 Total Students (plain text, no box)
doc.setFont("helvetica", "bold");
doc.text(
  `Total Downloads: ${filteredData.length}`,
  120, // X position (right side)
  16   // Same Y as Generated On
);

  // 🔹 Headers (Same as Excel)
  const headers = [
    "S.No",
    "Student Name",
    "Roll No",
    ...(isIntermediate ? ["Course"] : []),
    dynamicKey,
    "Section",
    "Father Name",
    "Phone",
  ];

  // 🔹 Body Data
  const bodyData = filteredData.map((row, index) => ([
    index + 1,
    `${row.firstName} ${row.lastName}`,
    row.rollNumber,
    ...(isIntermediate ? [row.course] : []),
    row.romanNumberClass,
    row.sections,
    `${row.fathersFirstName} ${row.fathersLastName}` || "N/A",
    row.primaryContact,
  ]));

  // Table
  doc.autoTable({
    startY: 22,
    head: [headers],
    body: bodyData,
    theme: "grid",
    styles: {
      fontSize: 9,
      halign: "center",
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
  });

  // Save file
  if (isIntermediate && interSelectedClass && interSelectedSection) {
    doc.save(`${interSelectedClass}-${interSelectedSection}_StudentsList.pdf`);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.save(`${sscSelectedClass}-${sscSelectedSection}_StudentsList.pdf`);
  } else {
    doc.save(`AllStudentsList.pdf`);
  }

  handleExportClose();
};

  

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
   
    if (
  board === "INTERMEDIATE" &&
  interSelectedClass &&
  interSelectedSection
) {
  link.download = `${interSelectedClass}-${interSelectedSection}_StudentsList.json`;
} else if (
  board === "SSC" &&
  sscSelectedClass &&
  sscSelectedSection
) {
  link.download = `${sscSelectedClass}_${sscSelectedSection}_StudentsList.json`;
} else {
  link.download = `AllStudentsList.json`;
}

    // link.download = `${selectedClass}-${selectedSection}_StudentsList.json`;
    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"   // ✅ Push left + right
  sx={{ marginBottom: 2 }}
>
  {/* ✅ LEFT SIDE - BACK + TITLE */}
  <Box display="flex" alignItems="center">
    <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>

    <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
      All Students List
    </Typography>
  </Box>

  {/* ✅ RIGHT SIDE - COUNT BOXES */}
  <Box
    sx={{
      display: 'flex',
      gap: 2,
    }}
  >
    {/* ✅ Total Students Box */}
    {/* <Box
      sx={{
        backgroundColor: '#e3f2fd',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 160,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
        Total Students:{" "}
        <Box component="span" sx={{ color: '#1565c0', fontWeight: 'bold' }}>
          {totalStudents}
        </Box>
      </Typography>
    </Box> */}

    {/* ✅ Present Students Box */}
    <Box
      sx={{
        backgroundColor: '#e8f5e9',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 160,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
      Total Downloads:{" "}
        <Box component="span" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
          {totalStudents}
        </Box>
      </Typography>
    </Box>
  </Box>
</Box>


          <Box display="flex" mb={3} flexWrap="wrap">
            <TextField
              label="Search by Name Or Mobile No"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }}
            />



{board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          // setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    value={sscSelectedSection}
    onChange={(e) => {
      setSscSelectedSection(e.target.value);
      // setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {/* Show placeholder if no sections 
    {sscSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Class
      </MenuItem>
    ) : (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl> */}

  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          // setMode("classSection");
        }}
        
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

  
    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      // setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>


  </>
)}



{/* <Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    setMode("scrolling");

    fetchGetAllTableData();
  }}
  variant="outlined"
  color="primary"

  sx={{marginLeft:'10px'}}
>
  Fetch OverAll Data
</Button> */}
{/* <Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    // setMode("scrolling");

    // ✅ Prevent API call if UserId is missing
    // if (UserId && oId) {
    //   fetchGetAllTableData();
    // } else {
    //   console.warn("Cannot fetch data: Missing UserId or oId");
    // }
  }}
  variant="outlined"
  color="primary"
  sx={{ marginLeft: '10px' }}
>
  Fetch OverAll Data
</Button> */}


 {/* {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}




            <Box sx={{ flexGrow: 1 }} />

            <Grid
              item
              xs={3}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                onClick={handleExportClick}
                style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem>

                {/* <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    color: "#388e3c",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f5e9",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#6a1b9a" }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                  />
                </MenuItem> */}
              </Menu>
            </Grid>
            {/* <Button
  variant="contained"
  sx={{
    backgroundColor: "#4caf50", // Custom green color
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c", // Darker green for hover
    },
  }}
  onClick={() => navigate("/NewAdmissionForm")}
>
  New Admission
</Button> */}
          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    S.No
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Student Id
                  </TableCell> */}
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Admission No
                  </TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Name
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Roll No
                  </TableCell>
                  {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Section
                  </TableCell>

                  
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Father Name
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Mother Name
                  </TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Gender
                  </TableCell> */}

                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Full Details
                  </TableCell> */}
                   {/* <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Delete
                  </TableCell> */}
                </TableRow>
              </TableHead>
              { loading ?(
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell>
      </TableRow> */}
                </TableBody>
              ) : filteredResults.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredResults.map((row, index) => (
                    <TableRow
                      key={row.customAdmissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.studentId}
                      </TableCell> */}

                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.customAdmissionNumber || "N/A"}
                      </TableCell> */}
                       <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {/* {`${row.firstName} ${row.lastName}` || "N/A"} */}
                      {row.firstName || row.lastName
                            ? `${row.firstName || ""} ${row.lastName || ""}`.trim()
                            : "N/A"} 
                      
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.rollNumber || "N/A"}
                      </TableCell>
                      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course || "N/A"}
                      </TableCell>
                      )}

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {["NURSERY", "LKG", "UKG"].includes(
                          row.romanNumberClass?.toString().trim()
                        )
                          ? row.romanNumberClass
                          : `${row.romanNumberClass}` || "N/A"}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections || "N/A"}
                      </TableCell>
                     
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                       {row.fathersFirstName || row.fathersLastName
    ? `${row.fathersFirstName || ""} ${row.fathersLastName || ""}`.trim()
    : "N/A"} 
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.mothersFirstName} {row.mothersLastName}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.primaryContact || "No Number"}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.gender || "N/A"}
                      </TableCell> */}

                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() =>
                            navigate(
                              `/StudentDetailView/${row.studentId}`
                            )
                          }
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.6rem", // Reduces the font size
                            height: "25px", // Reduces the height
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          View
                        </Button>
                      </TableCell> */}

                                        {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      type="button"
                      // onClick={() => handleDelete(row)}
                      onClick={() => handleOpenDeleteDialog(row)}
                      sx={{
                        backgroundColor: "#f44336", // Red color
                        color: "white",
                        fontSize: "0.6rem",
                        height: "25px",
                        minWidth: "32px",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#d32f2f",
                        },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </Button>
                  </TableCell> */}

                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>


{/* //delete dialog code */}
<Dialog
  open={openDeleteDialog}
  onClose={() => setOpenDeleteDialog(false)}
  maxWidth="xs"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      p: 2,
      boxShadow: 6,
    },
  }}
>
  {/* Icon */}
  <Box display="flex" justifyContent="center" mt={1}>
    <Box
      sx={{
        backgroundColor: '#fff3cd',
        borderRadius: '50%',
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // mb: 1,
        border: '2px solid #f5c2c7',
      }}
    >
      <Typography variant="h4" color="warning.main">!</Typography>
    </Box>
  </Box>

  {/* Title */}
  <DialogTitle
    sx={{
      textAlign: 'center',
      fontSize: '17px',
      fontWeight: 600,
      // mb: 1,
      px: 3,
    }}
  >
    Are you sure you want to delete this student{' '}
    <span style={{ color: '#d32f2f', fontWeight: 700 }}>
      {deleteTarget?.firstName?.toUpperCase()} {deleteTarget?.lastName?.toUpperCase()}
    </span>?
  </DialogTitle>

  <Divider variant="middle" />

  {/* Content */}
  <DialogContent sx={{ fontSize: '12px', px: 3 }}>
    <p style={{ marginBottom: 8 }}>
      Deleting this student will also <strong>permanently</strong> remove all related data:
    </p>
    <ul style={{ marginLeft: 20, paddingLeft: 10 }}>
      {/* <li>✅ <strong>All Student Payment history</strong> (Tuition Fee, Bus Fee, etc.)</li> */}
      <li>✅ <strong>Student Bus Registration data</strong></li>
      <li>✅ <strong>Student Bus Attendance records</strong></li>
      <li>✅ <strong>Student Academic Marks records</strong></li>
    </ul>

    {/* Confirmation Checkbox */}
    <Box display="flex" alignItems="center" mt={2}>
  <Checkbox
    checked={confirmChecked}
    onChange={(e) => setConfirmChecked(e.target.checked)}
    sx={{
      // color: 'error.main',
      p: 0.5, // reduce padding to avoid vertical misalignment
      mr: 1.2, // add right margin for spacing between checkbox and text
    }}
  />
  <Typography
    variant="body2"
    sx={{
      color: 'error.main',
      fontWeight: 'bold',
      whiteSpace: 'nowrap', // optional: prevent wrapping
    }}
  >
    Once deleted, this information cannot be recovered.
  </Typography>
</Box>

  </DialogContent>

  {/* Actions */}
  <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
    <Button
      onClick={() => setOpenDeleteDialog(false)}
      color="primary"
      variant="outlined"
      fullWidth
    >
      Cancel
    </Button>
    <Button
      onClick={confirmDelete}
      color="error"
      variant="contained"
      fullWidth
      disabled={!confirmChecked}
    >
      Yes, delete everything!
    </Button>
  </DialogActions>
</Dialog>



        </CardContent>
      </Card>
      <ToastContainer />
    </Box>
  );
};

export default StudentApplicationList;